import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SubscriptionPlanCard = ({ 
  plan, 
  isSelected, 
  onSelect, 
  isPopular = false,
  className = '' 
}) => {
  const handleSelect = () => {
    onSelect(plan?.id);
  };

  return (
    <div className={`relative border-2 rounded-lg p-6 transition-all duration-200 ${
      isSelected 
        ? 'border-primary bg-primary/5 shadow-lg' 
        : 'border-border bg-surface hover:border-primary/50 hover:shadow-md'
    } ${className}`}>
      {isPopular && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-accent text-accent-foreground px-3 py-1 rounded-full text-xs font-medium">
            Most Popular
          </span>
        </div>
      )}
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-text-primary mb-2">{plan?.name}</h3>
        <div className="mb-3">
          <span className="text-3xl font-bold text-text-primary">${plan?.price}</span>
          {plan?.price > 0 && <span className="text-text-secondary">/month</span>}
        </div>
        {plan?.trial && (
          <div className="flex items-center justify-center space-x-1 text-sm text-success">
            <Icon name="Clock" size={14} />
            <span>{plan?.trial} trial</span>
          </div>
        )}
        <p className="text-sm text-text-secondary mt-2">{plan?.description}</p>
      </div>
      <div className="space-y-3 mb-6">
        {plan?.features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <Icon 
              name={feature?.included ? "Check" : "X"} 
              size={16} 
              className={feature?.included ? "text-success mt-0.5" : "text-muted-foreground mt-0.5"} 
            />
            <span className={`text-sm ${
              feature?.included ? "text-text-primary" : "text-text-secondary line-through"
            }`}>
              {feature?.text}
            </span>
          </div>
        ))}
      </div>
      <Button
        variant={isSelected ? "default" : "outline"}
        fullWidth
        onClick={handleSelect}
        iconName={isSelected ? "Check" : "ArrowRight"}
        iconPosition="right"
      >
        {isSelected ? "Selected" : `Choose ${plan?.name}`}
      </Button>
      {plan?.limits && (
        <div className="mt-4 p-3 bg-muted rounded-md">
          <p className="text-xs text-text-secondary text-center">{plan?.limits}</p>
        </div>
      )}
    </div>
  );
};

export default SubscriptionPlanCard;